export default "__VITE_ASSET__DwbQ0yU___"